export default {
  serviceStartDate: '2021-01-01',

  feature: {
    showProjectId: true,
    accountText: 'customer',
    projectText: 'subscription',
  },

  topNavigation: {
    showAccountId: true,
  },

  billing: {
    summary: {
      dataPresentHours: 24, // 한국 시간 기준 오전 9시 (UTC 0시) 이후에 하루전 데이터가 존재한다고 가정함
      dataCompleteHours: 48, // 한국 시간 기준 오전 9시 (UTC 0시) 이후에 이틀 전 데이터가 완전하다고 가정함

      costShareItems: ['costByService', 'costByProject', 'costByRegion', 'costByCountry'],
    },
    costTrend: {
      enabled: false,
    },
    alarm: {
      enabled: false,
    },
  },

  // 빌원 인보이스를 보여줄 첫 청구월 (BO-3681). 그 이전 달은 hb2 가 이미 발행했다.
  // CSP 마다 이관 시점이 다르므로 default.js 공용값이 아니라 여기서 정한다.
  // 지금은 GCP 와 같은 달이지만 값이 같다는 것과 값을 공유한다는 것은 다르다 —
  // 한쪽 전환월을 바꿀 때 다른 쪽이 따라 움직이면 안 된다.
  //
  // 백엔드 하한(`billone.azure.hb2-invoice.min-visible-month = "202608"`, BO-3679)과
  // **같은 월**이어야 한다. 백엔드가 더 늦으면 여기서 보여주려는 달이 에러 없이
  // 빈 채로 내려온다. 형식 주의: 여기는 하이픈 있는 `YYYY-MM`, 백엔드는 `yyyyMM`.
  invoice: {
    billone: {
      firstMonth: '2026-08',
    },
  },
};
